import React from 'react';
import BackButton from './backButton';

const FoundationRepair = () => {
    return (
        <div className="container mx-auto p-4 pt-28">
            <h1 className="text-3xl font-semibold mb-4">Foundation Repair and Parging</h1>
            <BackButton />

            <p>
                Protect the structural integrity of your property with our comprehensive foundation repair and parging services. Whether you're dealing with cracks, deterioration, or the need for a fresh parging coat, our solutions are designed to address the specific needs of your concrete foundation, both inside and outside.
            </p>

            <div className="flex flex-wrap justify-center">
                <div className="p-2">
                    <img src="/images/services/foundation-repair/cornerfoundation.webp" alt="Foundation Repair" className="mx-auto rounded-lg shadow-lg" />
                </div>
            </div>

            <p>
                Cracks in your foundation or deteriorating parging can lead to various issues, including water seepage and compromised structural stability. Our expert team specializes in identifying and repairing foundation issues promptly, ensuring the longevity of your property and preventing further damage.
            </p>

            <p>
                Inside your property, we address water seepage concerns in basements or crawl spaces, providing effective solutions to manage and redirect water flow. Outside, our services prevent water from pooling around the foundation, minimizing the risk of foundation damage and related structural issues.
            </p>

            <p>
                Whether you need a parging refresh or a comprehensive foundation repair, our tailored solutions cater to both residential and commercial properties. Contact us today to discuss your specific requirements, and let our experienced team ensure that your property remains resilient, structurally sound, and protected from potential water-related issues.
            </p>
        </div>
    );
};

export default FoundationRepair;
